import * as React from 'react'
import { connect } from 'react-redux'
import { ApplicationState } from '../../store'
import { NavLink as RouterNavLink } from 'react-router-dom';
import { Row, Col, Spinner, ListGroup, ListGroupItem, Button, 
    Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Badge, Table } from 'reactstrap';
import { Redirect } from 'react-router-dom';
import moment from 'moment';
import BlobUtil from '../../utils/blobUtil';

interface IState {
    modal: boolean
    childTerm : string
    searchSorting : string
    searchSortingDisplay : string
    searchSortingDropDownOpen : boolean
    redirect: boolean
    redirectId: string
}
// Separate state props + dispatch props to their own interfaces.
interface PropsFromState {
    term:string
    sorting:string
    totalDocument : number
    offset : number
    limit : number
    data: any[]
    loading: boolean
    downloading: boolean
}

// We can use `typeof` here to map our dispatch types to the props, like so.
interface PropsFromDispatch {
    onLoadMore: any
    onSorting:any
    onDownload:any
}

// Combine both state + dispatch props - as well as any props we want to pass - in a union type.
type AllProps = PropsFromState & PropsFromDispatch;


class ListResult extends React.Component<AllProps, IState> {
    sortList = [
        {"Display":"Latest", "Expression":"c.date desc"},
        {"Display":"Order No", "Expression":"c.orderNo"}
    ];
    /**
     *
     */
    constructor(props: AllProps) {
        super(props);
        this.state = {
            modal: false,
            childTerm : this.props.term,
            searchSortingDisplay: 'Latest',
            searchSorting: this.props.sorting,
            searchSortingDropDownOpen: false,
            redirect: false,
            redirectId : ""
        };

        this.onInputChange = this.onInputChange.bind(this);
        this.onChangeSorting = this.onChangeSorting.bind(this);
        this.downloadInvoice = this.downloadInvoice.bind(this);
        //this.test = this.test.bind(this);
    }
    public componentDidMount() {
        
    }
    componentDidUpdate(prevProps: AllProps) {
        if (prevProps.sorting != this.props.sorting){
            // if (this.props.sorting == ""){
            //     this.setState({ searchSortingDisplay: "Title" });
            // }
            this.setState({ searchSortingDisplay: this.SortExpressionDisplay(this.props.sorting) });
        }
    }

    onInputChange(e:any) {
        this.setState({ childTerm: e.target.value });
    }

    SortExpressionDisplay(sortExpression:string){
        let foundSort = this.sortList.find(e => e.Expression.toLowerCase() === sortExpression.toLowerCase());
        if (foundSort){
            return foundSort.Display;
        }else{
            return this.sortList[0].Display; // Get First
        }
    }

    onChangeSorting(e:any){
        var sortText = e.currentTarget.textContent;
        let foundSort = this.sortList.find(e => e.Display.toLowerCase() === sortText.toLowerCase());
        var sortExpression = "";
        if (foundSort){
            sortExpression = foundSort.Expression;
        }else{
            sortExpression = this.sortList[0].Expression; // Get First
        }
        this.setState({ 
            searchSortingDisplay : sortText, 
            searchSorting: sortExpression}, () => {
            this.props.onSorting(this.state);
        })
    }

    onRowSelected(id:string, e:any){
        this.setState({redirect : true, redirectId: id}, () => {
        });
    }

    async getInvoiceUrl(oId:string, fileName:string) {
        let blobRequestUrl = await new BlobUtil().GetBlob(oId ,fileName);
        return blobRequestUrl;
    }

    async downloadInvoice(oId:string, orderId:string){
        let fileName = orderId + "-inv.pdf";
        let invoiceURL = await this.getInvoiceUrl(oId, fileName);
        console.log("Invoice URL:"+ invoiceURL);
        window.open(invoiceURL);
    }

    public render() {   
        const tdStyle = {
             padding : "15px"
          };

        const showLoadMore = (this.props.offset + this.props.limit) < this.props.totalDocument;
        const toggleSortingDropDown = () => this.setState({searchSortingDropDownOpen : !this.state.searchSortingDropDownOpen}); 

        if (this.state.redirect){
            return (
                <Redirect push to={{
                    pathname: '/organisers/' + this.state.redirectId
                }} />
            )
        }
        else{
            return (
                <div onScroll={this.props.onLoadMore.bind(this, this.state)}>
                    <ListGroup>
                        <ListGroupItem>
                            <Row>
                                <Col lg="9" >
                                    <span style={{ fontSize:"larger" }}>{this.props.totalDocument} result(s)</span>&nbsp;
                                    <Button color="warning" onClick={this.props.onDownload} disabled={this.props.downloading}><i className="fas fa-download mr-1"></i>Download file</Button> 
                                    <Spinner color="danger" hidden={!this.props.downloading} />
                                </Col>
                                <Col lg="3" >
                                    <Dropdown isOpen={this.state.searchSortingDropDownOpen} toggle={toggleSortingDropDown}>
                                        <DropdownToggle caret color="secondary" block>
                                            <i className="fas fa-sort mr-1"></i>
                                            {this.state.searchSortingDisplay}
                                        </DropdownToggle>
                                        <DropdownMenu>
                                            <DropdownItem header>Sort</DropdownItem>
                                            <DropdownItem divider/>
                                            {
                                                this.sortList.map(item =>(
                                                    <DropdownItem onClick={this.onChangeSorting}>{item.Display}</DropdownItem>
                                                ))
                                            }
                                        </DropdownMenu>
                                    </Dropdown>
                                </Col>
                            </Row>
                        </ListGroupItem>
                        <Table>
                            <thead>
                                <tr>
                                    <th>Date Ordered</th>
                                    <th>Order #</th>
                                    <th>User Name</th>
                                    <th>Course #</th>
                                    <th>Total</th>
                                    <th>Details</th>
                                    <th>Invoice</th>
                                </tr>
                            </thead>
                            <tbody>
                            {
                                this.props.data.map(item =>(
                                    <tr key={item.id}>
                                        <td>{moment(item.date).format("DD-MM-YYYY HH:mm:ss")}</td>
                                        <td>{item.orderNo}</td>
                                        <td>{item.userName}</td>
                                        <td>{item.noOfCourses}</td>
                                        <td>{item.cartItems.totAmt?.toFixed(2)}</td>
                                        <td style={{width:"110px"}}><RouterNavLink to={"/orders/" + item.id }><Button color="primary"><i className="fas fa-eye mr-1"></i>View</Button></RouterNavLink></td>
                                        <td style={{width:"150px"}}><Button color="default" onClick={this.downloadInvoice.bind(this, item.oId, item.id)}><i className="fas fa-download mr-1"></i>Download</Button></td>
                                    </tr>
                                ))
                            }
                         </tbody>
                        </Table>
                        <ListGroupItem key="loadmore">
                            <Row>
                                <Col lg="12">
                                    <Spinner color="warning" hidden={!this.props.loading} />
                                </Col>
                            </Row>
                            <Row>
                                <Col lg="12">
                                    <Button color="secondary" 
                                        onClick={this.props.onLoadMore.bind(this, this.state)} block
                                        hidden={!showLoadMore} >
                                        Load More
                                    </Button>
                                </Col>
                            </Row>
                        </ListGroupItem>
                    </ListGroup>
                </div>
            )
        }
    }
}

// It's usually good practice to only include one context at a time in a connected component.
// Although if necessary, you can always include multiple contexts. Just make sure to
// separate them from each other to prevent prop conflicts.
const mapStateToProps = (state: ApplicationState) => ({
    
})

// mapDispatchToProps is especially useful for constraining our actions to the connected component.
// You can access these via `this.props`.
const mapDispatchToProps = {

}

// Now let's connect our component!
// With redux v4's improved typings, we can finally omit generics here.
export default connect(
    mapStateToProps
)(ListResult)